const defaultState = {
  cars:[],
  carBrand: [],
  carModel: [],
  carType: [],
  error: "",
  carRequest: false,
};

const bookingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CAR_LIST_REQUEST":
      return {
        ...state,
        carRequest: true,
      };
    case "CAR_LIST_REQUEST_SUCCESS":
      return {
        ...state,
        carRequest: false,
        ...action.payload,
      };
    case "CAR_LIST_REQUEST_FAILED":
      return {
        ...state,
        carRequest: false,
        erros: action.payload,
      };
    default:
      return state;
  }
};

export default bookingReducer;



// WEBPACK FOOTER //
// src/store/reducers/car.js